module.exports = __webpack_public_path__ + "static/media/IMG_3371.10561fba.JPG";